/**
 * deprecated is a method that should be used each
 * time a component wants to deprecate a prop and explain to
 * the consumer how to proceed.
 *
 * This method will be ignored in production code.
 *
 * @param  {Function} propType    Any valid PropType.
 * @param  {String} explanation   Explanation for the consumer.
 * @return {Exception}            Return new Error if prop is passed.
 */
export default function deprecated(propType) {
  let explanation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return function validate(props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== "undefined") {
      const message = `"${propName}" property of "${componentName}" has been deprecated. ${explanation}`.trim();
      return new Error(message);
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType(props, propName, componentName, ...rest);
  };
}